module.exports = __webpack_public_path__ + "img/puzzle2_w.f67f1fa5.svg";